import type { Variants } from 'framer-motion';

export enum ToastVariant {
    Hidden = 'hidden',
    Show = 'show',
}

export const toastVariants: Variants = {
    [ToastVariant.Hidden]: {
        opacity: 0,
        // TODO: This is a magic number!
        // We have no guarantee that a `Toast` will be under `100px` tall.
        // We might be able to improve this if `framer-motion` allows
        // a different easing on `entrance` (backOut) vs `exit` (backIn).
        // Otherwise, we will need to go back to using `translateY`
        // and tracking `offsetHeight`.
        marginBottom: '-120px',
    },
    [ToastVariant.Show]: {
        opacity: 1,
        marginBottom: 0,
    },
};
